import PastTournamentResultsComponent from "../../components/PastTournamentResultsComponent";
import PrivateLayout from "../../layouts/PrivateLayout";
import { useParams } from "react-router-dom";

function PastTournamentResults() {
  const backgroundImage = "/ww-wallpaper.webp";
  const { id } = useParams();

  return (
    <PrivateLayout backgroundImage={backgroundImage}>
      <PastTournamentResultsComponent id={id} />
    </PrivateLayout>
  );
}

export default PastTournamentResults;
